import { Box } from '@pocketlaw/tetris';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { GroupMessage } from './GroupMessage';
import { SigningOrder } from './SigningOrder';
export function Settings() {
    const { properties: providerProperties } = useEsigningProviderMetadata();
    const { canUseSigningOrder, canUseEsigningMessages } = providerProperties;
    return (<Box flexDirection="column" gap="lg" p="xl">
      {canUseSigningOrder && <SigningOrder />}
      {canUseEsigningMessages && <GroupMessage />}
    </Box>);
}
